const ChartExportContext = React.createContext()

export const ChartExportProvider = ({ children }) => {
  const [exportConfig, setExportConfig] = React.useState(null)

  const openChartExport = React.useCallback((config) => {
    setExportConfig(config)
  }, [])

  const closeChartExport = React.useCallback(() => {
    setExportConfig(null)
  }, [])

  return (
    <ChartExportContext.Provider value={{ exportConfig, openChartExport, closeChartExport }}>
      {children}
    </ChartExportContext.Provider>
  )
}

ChartExportProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export const useChartExportContext = () => React.useContext(ChartExportContext)
